import React from "react";
import { Link } from "react-router-dom";

const ComingSoon: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background px-6 text-center">
      <img
        src="/images/logo.png"
        alt="Pheefee"
        className="w-20 h-20 sm:w-24 sm:h-24 mb-6 rounded-full"
      />
      <h1 className="text-3xl sm:text-5xl font-bold text-foreground mb-4">Pheefee</h1>
      <p className="text-lg sm:text-xl text-muted-foreground mb-2">
        Virtual dog training, on demand.
      </p>
      <p className="text-base sm:text-lg text-primary font-semibold mb-12">
        Launching soon.
      </p>
      <Link
        to="/login?trainerOnly=1"
        className="text-xs text-muted-foreground/70 hover:text-primary underline underline-offset-4 transition-colors"
      >
        Trainers &rarr;
      </Link>
    </div>
  );
};

export default ComingSoon;
